import request from '@/utils/request';

export function channelDateApi() {
    return {
        // 渠道号头部数据
        referralCollectHeader: params => {
            return request({
                url: '/admin/referralcollect/header',
                method: 'get',
                params,
            });
        },
        // 渠道号列表数据
        referralCollect: params => {
            return request({
                url: '/admin/referralcollect/index',
                method: 'get',
                params,
            });
        },
        // 渠道号历史数据
        referralCollectHistory: id => {
            return request({
                url: '/admin/referralcollect/history?id=' + id,
                method: 'get'
            });
        },
    };
}
